import { FC } from "react";
import { MdDeleteOutline } from "react-icons/md";
import "./style.css";

interface Props {
  tags: string[];
  onRemoveTagClick: (tag: string) => void;
}

export const TagList: FC<Props> = ({ tags, onRemoveTagClick }) => {
  return (
    <div>
      <p>Added tags: {tags?.length}</p>
      <div className="tag-list-wrapper">
        {tags?.map((tag) => (
          <p
            className="tag-item"
            key={tag}
            onClick={() => onRemoveTagClick(tag)}
          >
            {tag.toUpperCase()}
            <MdDeleteOutline />
          </p>
        ))}
      </div>
    </div>
  );
};
